import {
  ConfigurationState, ConfigurationTreeNodeModel,
  RootState, StoreConstants
} from '@/types';
import { ConfigurationService } from '@/services/ConfigurationService';
import { ActionTree } from 'vuex';

export const actions: ActionTree<ConfigurationState, RootState> = {
  async [StoreConstants.Configuration.Actions.GetConfigurationTree]({ commit, state }) {
    try {
      const tree = await ConfigurationService.getConfigurationTreeAsync();
      commit(StoreConstants.Configuration.Mutations.SetTree, tree);
    } catch (error) {
      commit(StoreConstants.Configuration.Mutations.SetTree, {} as ConfigurationTreeNodeModel[]);
    }
  },
  [StoreConstants.Configuration.Actions.SetSelectedNodeToExpandOnMount]({ commit, state }) {
    commit(StoreConstants.Configuration.Mutations.SetSelectedNodeToExpandOnMount);
  },
  [StoreConstants.Configuration.Actions.ResetSelectedNodeToExpandOnMount]({ commit, state }) {
    commit(StoreConstants.Configuration.Mutations.ResetSelectedNodeToExpandOnMount);
  }
};